import { REQUEST_FETCH_DMAS, FETCH_DMAS_SUCCESS, FETCH_DMAS_ERROR } from './actionTypes';

export const requestFetchDMAs = () => ({ type: REQUEST_FETCH_DMAS });

export const fetchDMAsSuccess = listOfDMAs => ({ type: FETCH_DMAS_SUCCESS, payload: listOfDMAs });

export const fetchDMAsError = () => ({ type: FETCH_DMAS_ERROR });
